import * as React from 'react'
import controlStore from '../../../store/controlStore.ts'
import { clearRoute } from './directionHelper.tsx'

interface Props {
}

export const ClearDirectionsButton: React.FC<Props> = (props) => {
    const {} = props

    const visible = controlStore(s => s.directionsVisible)

    const component = (
        <div className={'btn btn-lg btn-secondary'}
             onClick={() => {
                 clearRoute()
                 controlStore.getState().setDirectionsVisible(false)
             }}
        >
            Clear Directions
        </div>
    )

    return visible ? component : null
}